<div class="dvsn-form-builder-side-menu">
    <div
        class="menu-parent"
        v-for="parent in menu"
    >
        <h4>{{ parent.label }}</h4>

        <ul class="menu-children">
            <li v-for="child in parent.children"
                class="menu-child"
                :class="{ 'is--active': child.id === active }"
            >
                <router-link
                    :title="child.label"
                    :to="{ name: child.route }"
                >
                    {{ child.label }}
                </router-link>
            </li>
        </ul>
    </div>
</div>
